export const TEST_TYPE_OPTIONS = {
  price_test: "Price Test",
  shipping_test: "Shipping Test",
  content_test: "Content Test",
  offer_test: "Offer Test",
  checkout_test: "Checkout Test",
  personalizations: "Personalization",
  no_test_type: "No Test Type",
} as const;

export const experienceTypeToTestTypeKey = (
  type: string
): keyof typeof TEST_TYPE_OPTIONS => {
  if (type === "pricing") {
    return "price_test";
  }
  if (type === "shipping") {
    return "shipping_test";
  }
  if (type === "personalization/offer") {
    return "offer_test";
  }
  if (type === "checkoutBlock") {
    return "checkout_test";
  }
  if (type.startsWith("content/")) {
    return "content_test";
  }
  if (type.startsWith("personalization")) {
    return "personalizations";
  }
  return "no_test_type";
};
